import { SKIP_FORBIDDEN } from './httpConfig';

export class GsePricingAnalyticsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getMarginAttribution(params) {
    return this.#http.get('/api/pricing/analytics/margin-attribution', { params });
  }

  async getLeakageByCause(params) {
    return this.#http.get('/api/pricing/analytics/leakage-by-cause', { params });
  }

  async replay(body) {
    return this.#http.post('/api/pricing/replay', body);
  }

  // Margin Center MC-6 (DEV-4968): the 4-leg base/LLPA/SRP/margin -> client-price split for a sample —
  // a thin re-projection of the same deterministic replay POST /pricing/replay uses, over GET so it's
  // cacheable/bookmarkable. params: gsePricingPullId, product, noteRate, lockDays, servicingOption
  // (required) + specifiedPool, servicerId, marginSnapshotId, correlationId (optional).
  async getSampleAttribution(params) {
    return this.#http.get('/api/pricing/analytics/sample-attribution', { params });
  }

  // DEV-4979/MC-16: fair-lending surveillance — one k-anonymized result (cross-cohort KPIs +
  // per-cohort aggregates) over QuotedOptionHistory, on this SAME analytics controller (reuse-first;
  // no new service). The k-anonymity suppression floor is enforced UPSTREAM in Skynet.Loans — this
  // call only ever receives already-anonymized cohort aggregates, never a raw protected-class field.
  async getSurveillance(params) {
    return this.#http.get('/api/pricing/analytics/surveillance', { params });
  }

  // LEN-804: Today reads the month's margin on a page any Margin Center claim can open, so a caller
  // without the analytics claim must get an inline empty card, not the global forbidden reload.
  async getMarginAttributionInline(params) {
    return this.#http.get('/api/pricing/analytics/margin-attribution', {
      ...SKIP_FORBIDDEN,
      params,
    });
  }
}
